import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ContractedOverrideItem from '../../../Domain/ContractedOverrideItem';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';

export default class ContractedOverrideWindowDescription {
  static titleForCreate = 'Override Contracted Assignments';
  static titleForEdit = 'Override Contracted Assignments';
  static itemType = ContractedOverrideItem;
  static serviceFunction = (item) => PlanningDetailsItemService.UpdateContractedAssignmentsOverride(item);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Override',
      fields: [
        {
          fieldName: 'OriginalTotal',
          label: 'Original Contracted Total',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
        },
        {
          fieldName: 'DistributionType',
          label: 'Distribution Type *',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: [
            { value: 'even', label: 'Distribute Evenly' },
            { value: 'perItem', label: 'Per Item' },
          ],
        },
        {
          fieldName: 'NewTotal',
          label: 'New Contracted Total *',
          className: 'col-12',
          type: InputTypesEnum.Number,
          hide: (item) => item.DistributionType !== 'even',
          validityChecker: (field, editedItem) => {
            const val = parseInt(editedItem.NewTotal);
            if (isNaN(val) || val < 0) return 'Value must be >= 0';
            if (val > editedItem.OriginalTotal) return `Value must be <= ${editedItem.OriginalTotal}`;
            return '';
          },
        },
        {
          fieldName: 'Items',
          valueField: 'override',
          labelField: 'label',
          className: 'col-12',
          type: InputTypesEnum.Number,
          hide: (item) => item.DistributionType !== 'perItem',
          validityChecker: (field, editedItem, index) => {
            if (index === undefined) return '';
            const val = parseInt(editedItem.Items[index].override);
            if (isNaN(val) || val < 0) return 'Value must be >= 0';
            const total = editedItem.Items.reduce((sum, i) => sum + (parseInt(i.override) || 0), 0);
            if (total > editedItem.OriginalTotal)
              return `Total (${total}) exceeds original (${editedItem.OriginalTotal})`;
            return '';
          },
        },
      ],
    },
  ];
}
